export const getPath = (string) => {
	return string.split("/")[1];
};
